import './index.css'

import React, { Component } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

class AdminLogin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      loading: false,
      error: null,
    }
  }

  componentDidMount() {
    if (localStorage.getItem('adminData')) {
      this.props.history.push('/admin')
    }
  }

  handleChange = e => {
    this.setState({ [e.target.id]: e.target.value, error: null })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.setState({ loading: true, error: null })

    axios
      .post(`${process.env.REACT_APP_API_URL}/admin/login`, {
        email: this.state.email,
        password: this.state.password,
      })
      .then(res => {
        localStorage.setItem('adminData', JSON.stringify({ token: res.data.token }))
        this.props.history.push('/admin')
      })
      .catch(err => {
        const message = err.response?.data?.message || 'Login failed'
        this.setState({ loading: false, error: message })
      })
  }

  render() {
    const { email, password, loading, error } = this.state

    return (
      <div className="create-home">
        <Link to="/" className="link-home">
          <img src="/logo.png" alt="makeresume.co" className="logo-home" />
        </Link>
        <div className="create-home-container" style={{ width: '420px', minHeight: '360px' }}>
          <form
            onSubmit={this.handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '40px 50px',
              height: '100%',
            }}
          >
            <h1 style={{ marginBottom: '8px' }}>Admin Login</h1>
            <span style={{ fontSize: '12px', color: '#aaa', marginBottom: '8px' }}>
              makeresume.co
            </span>

            {error && <div className="admin-login-error">{error}</div>}

            <input
              type="email"
              id="email"
              placeholder="Email"
              value={email}
              onChange={this.handleChange}
              required
              style={{ marginTop: '20px', width: '100%' }}
            />
            <input
              type="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={this.handleChange}
              required
              style={{ marginTop: '16px', width: '100%' }}
            />

            <button
              type="submit"
              disabled={loading}
              style={{ marginTop: '24px', width: '100%' }}
            >
              {loading ? 'Logging in…' : 'LOGIN'}
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default AdminLogin
